import { render } from "./ShareVariant.vue?vue&type=template&id=1f77088e"
import script from "./ShareVariant.vue?vue&type=script&lang=js"
export * from "./ShareVariant.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__